<!--suppress HtmlUnknownTarget -->
<template>
  <div id="featureDualContentCardRoot">
    <div id="container">
      <div id="titleContainer">
        <div id="featureTitle"><span>{{ name }}</span></div>
        <div id="featureTitleDescription"><span>{{ description }}</span></div>
      </div>
      <div id="leftContainer">
        <FeatureInfoContainerCard v-on:is-expanded="toggleLeft" style="height: 100%"
                                  :open-icon-position="iconPosition"
                                  background-color="#FAFAFA">
          <div id="leftContent">
            <transition name="fade">
              <div v-if="!leftExpanded" id="leftTitle" class="title h3">
                <span v-html="content[0].description"></span></div>
            </transition>
            <transition name="fade">
              <div v-if="!leftExpanded" id="leftImage"><img :src="leftImage" @contextmenu.prevent/></div>
            </transition>
            <transition name="fade">
              <div v-if="leftExpanded" id="leftExpandedDescription">
                <span v-html="content[0].expandedDescription"></span>
              </div>
            </transition>
          </div>
        </FeatureInfoContainerCard>
      </div>
      <div id="rightContainer">
        <FeatureInfoContainerCard v-on:is-expanded="toggleRight" style="height: 100%" :open-icon-position="iconPosition"
                                  background-color="#FAFAFA">
          <div id="rightContent">
            <transition name="fade">
              <div v-if="!rightExpanded" id="rightTitle" class="h3">
                <span>{{ content[1].description }}</span></div>
            </transition>
            <transition name="fade">
              <div v-if="!rightExpanded" id="rightImage"><img :src="rightImage" @contextmenu.prevent/>
              </div>
            </transition>
            <transition name="fade">
              <div v-if="rightExpanded" id="rightExpandedDescription">
                <span v-html="content[1].expandedDescription"></span>
              </div>
            </transition>
          </div>
        </FeatureInfoContainerCard>
      </div>
    </div>
  </div>
</template>

<script>
import FeatureInfoContainerCard from "./FeatureInfoContainerCard";

export default {
  name: "FeatureDualContentCard",
  components: {FeatureInfoContainerCard},
  props: {
    height: {
      type: Number,
      default: 0
    },
    name: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    taglineDescription: {
      type: String,
      default: ""
    },
    tagline: {
      type: String,
      default: ""
    },
    content: {
      type: Array,
    },
  },
  data() {
    return {
      leftExpanded: false,
      rightExpanded: false
    }
  },
  computed: {
    leftImage() {
      return require('../../assets/' + this.content[0].media);
    },
    rightImage() {
      return require('../../assets/' + this.content[1].media);
    },
    iconPosition() {
      if (this.height > 812)
        return 3
      else
        return 1
    }
  },
  methods: {
    toggleLeft(value) {
      this.leftExpanded = value
      this.$gtag.event('featureToggle', {
        eventCategory: 'offline_data',
        eventAction: 'click',
        eventValue: value ? 1 : 0
      })
    },
    toggleRight(value) {
      this.rightExpanded = value
      this.$gtag.event('featureToggle', {
        eventCategory: 'online_data',
        eventAction: 'click',
        eventValue: value ? 1 : 0
      })
    },
  },
}
</script>
<style lang="scss" src="../../styles/featuredualcontentcard.scss" scoped/>